import {sendLog} from "../common/SendLog";

//Взять информацию об операторе
export const operatorInfo = (serverApi, title, docSessionCode, debag, appLogicType) => {
    //Название компании
    serverApi.getOperatorInfo(docSessionCode, debag, appLogicType).then((response) => {
        sendLog(serverApi, title, 'Взять информацию об операторе', 'getOperatorInfo', false, response);
        if (response.status == 200) {
            localStorage.setItem("operator_name", response.data.name);

            const callArray = response.data.call;
            const siteArray = response.data.site;

            // Преобразуем массив в строку и сохраняем в localStorage
            localStorage.setItem("phone", JSON.stringify(callArray));
            localStorage.setItem("site", JSON.stringify(siteArray));
        }
    }).catch((error) => {
        console.log(error);
        sendLog(serverApi, title, 'Взять информацию об операторе', 'getOperatorInfo', true, error);
    });
};
